/* ═══════════════════════════════════════════════════════════════════════════
   Public AI Translation — token decoding
   KAPsurvey links here with ?token=<JWT>. The token seen from KAPsurvey so far
   is signed with "alg":"none" — there is no signature to verify, so decoding
   it on the frontend loses nothing a backend check would have given us. If
   KAPsurvey later signs these for real (HS256/RS256), verification MUST move
   to the backend before this content is trusted for anything beyond display.
   ═══════════════════════════════════════════════════════════════════════════ */

export interface PublicTranslationTokenPayload {
  iss: string;
  aud: string;
  iat: number;
  exp: number;
  surveyName: string;
  languageName: string;
  survey: Record<string, unknown>;
}

const base64UrlDecode = (segment: string): string => {
  const base64 = segment.replace(/-/g, "+").replace(/_/g, "/");
  const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
  const binary = atob(padded);
  const percentEncoded = binary
    .split("")
    .map((c) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0"))
    .join("");
  return decodeURIComponent(percentEncoded);
};

export const decodePublicTranslationToken = (
  token: string
): PublicTranslationTokenPayload => {
  const parts = token.split(".");
  if (parts.length < 2) {
    throw new Error("Malformed token");
  }
  return JSON.parse(base64UrlDecode(parts[1]));
};

export const isTokenExpired = (payload: PublicTranslationTokenPayload): boolean => {
  return payload.exp * 1000 < Date.now();
};
